import Component from '@glimmer/component';
import { action } from '@ember/object';
import { pledgeFrequencyLabels } from 'donor-elf-web/lib/pledge-utils';
import { tracked, cached } from '@glimmer/tracking';
import ReviewItemModel from 'donor-elf-web/models/review-item';
import moment from 'moment';

interface ComponentArgs {
  reviewItem: ReviewItemModel;
  onSave: (reviewItem: ReviewItemModel) => void;
}

export default class ReviewItemCardGiftBeforePledgeStartDateComponent extends Component<ComponentArgs> {
  @tracked saving = false;
  @tracked saveError?: any;

  get pledgeFrequencyLabel() {
    return pledgeFrequencyLabels[this.args.reviewItem.custom.pledge.frequency];
  }

  // return { number: integer, timespan: 'days|months' }
  @cached
  get dateDiff(): { number: number; timespan: string } {
    let val = {
      number: 0,
      timespan: 'days',
    };
    val.number = moment(this.args.reviewItem.custom.pledge.start_date).diff(
      moment(this.args.reviewItem.custom.line.trans_date),
      'days',
    );
    if (val.number < 2) {
      val.timespan = 'day';
    } else if (val.number > 45) {
      val.number = moment(this.args.reviewItem.custom.pledge.start_date).diff(
        moment(this.args.reviewItem.custom.line.trans_date),
        'months',
      );
      val.timespan = 'months';
    }
    return val;
  }

  @action
  async handleNo() {
    this.saving = true;
    this.args.reviewItem.answered = true;
    await this.args.reviewItem.save();
    this.args.onSave(this.args.reviewItem);
  }

  @action
  async handleYes() {
    this.saving = true;
    this.args.reviewItem.answered = true;
    this.args.reviewItem.saveCommand = {
      update_pledge_to_line_trans_date: true,
    };
    try {
      await this.args.reviewItem.save();
      this.args.onSave(this.args.reviewItem);
    } catch (error) {
      this.saveError = error;
    }
  }
}
